import React, {Component} from "react";
import toastr from "toastr";
import App from "../../../App";

import ToastOptions from "../../../common/toast/toastr-config.js";
import Loading from "../../../common/Loading/Loading";
import AccountProductHeader from "./components/AccountProductHeader";
import AccountService from "../../../services/account-service"
import HistoryBackLink from "../../../common/BackLink/HistoryBackLink";

import "./AccountApiProductDetails.css";
import ActivationButton from "../../../common/ActivationButton/ActivationButton";
import Tab from "react-bootstrap/Tab";
import Attributes from "../../account-product-details/account-api-product-details/components/Attributes";
import Tabs from "react-bootstrap/Tabs";
import ApiKeys from "./components/ApiKeys";
import Services from "./components/Services";
import Permissions from "../../../authentication/Permissions";
import AuthorizationService from "../../../services/authorization-service";

class AccountApiProductDetails extends Component {
  mount = false;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingDevelopers: true,
      account: {},
      sub: {
        credentials: []
      }
    };
  }

  componentWillMount() {
    this.mount = true;
    this.setState({
      account: {...this.props.location.state.account},
      sub: {...this.props.location.state.sub},
      loading: false
    });
  }

  componentWillUnmount() {
    this.mount = false;
  }

  updateSubscription = async (sub, successMessage) => {
    try {
      this.setState({isDialogLoading: true});

      const response = await AccountService.saveSubscription(this.state.account.id, sub);
      this.setState({
        sub: response.data,
        isEditAccountProductModalVisible: false,
        isDialogLoading: false
      });
      toastr.options = ToastOptions;
      toastr.success(successMessage ? successMessage : "Account Product has been updated.");
        return response;
      } catch (error) {
        toastr.options = ToastOptions;
        toastr.error(error.message, '', error.lineNumber);
        this.setState({loading: false, isDialogLoading: false});
      }
  }


  updateSubStatus = async (sub) => {
    try {
      let message = sub.isActive ? "deactivated." : "activated.";
      let localSub = {...sub, isActive: !sub.isActive}
      this.updateSubscription(localSub, "The subscription has been " + message);
      this.setState({isEditProductModalVisible: false});
    } catch (error) {
      this.setState({isDialogLoading: false});
    }
  };

  addKey = async (sub) => {
    try {
      const response = await AccountService.addKey(this.state.account.id, sub);
      this.setState({
        sub: response.data
      })
    } catch (error) {
      this.setState({isDialogLoading: false});
      toastr.options = ToastOptions;
      toastr.error(error.message, '', error.lineNumber);
    }
  }

  render() {
    const userName = this.props.location.state.userName;
    return (
      <App {...this.props}>
        {this.state.loading && <Loading className="account-loading"/>}
        <HistoryBackLink directionName={userName ? userName : this.state.account.name}/>

        <div className="account-product-details">
          <div className="account-product-title">
            <span className="name">{this.state.sub.connectedProducts[0].productName}</span>
            {AuthorizationService.hasPermission(Permissions.subscription.changeStatus) &&
            <span className="edit-buttons">
              {!this.state.sub.isSynchronize &&
              <ActivationButton
                  toggleFunction={this.updateSubStatus}
                  description={` subscription with unitId: ${this.state.sub.unitId}`}
                  isActive={this.state.sub.isActive}
                  item={this.state.sub}
                  header={"Subscription"}
              />
              }
              </span>
            }
          </div>

          <AccountProductHeader
              account={this.state.account}
              sub={this.state.sub}
              updateSubscription={this.updateSubscription}
          />

          <Tabs defaultActiveKey="apikeys" id="uncontrolled-tab-example">

            {this.state.sub.credentials && (
                <Tab eventKey="apikeys" title="API Keys">
                  <ApiKeys
                      account={this.state.account}
                      updateSubscription={this.updateSubscription}
                      sub={this.state.sub}
                      addKey={this.addKey}
                  />
                </Tab>
            )}
            <Tab eventKey="defAttributes" title="Services">
              <Services
                  account={this.state.account}
                  updateSubscription={this.updateSubscription}
                  sub={this.state.sub}
              />
            </Tab>

            <Tab eventKey="attributes" title="Attributes">
              <Attributes
                  sub={this.state.sub}
                  account={this.state.account}
                  updateSubscription={this.updateSubscription}
              />
            </Tab>
          </Tabs>

        </div>

      </App>
    );
  }
}

export default AccountApiProductDetails;



// WEBPACK FOOTER //
// ./src/accounts/account-product-details/account-api-product-details/AccountApiProductDetails.js